






























































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModalCrear.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import Confirmation from '@/components/Confirmation.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { fetchMS } from '@/pantallas/Conecta/PreparacionEquipos/fetchMS';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    NavegacionModalCrud,
    Confirmation,
    FormFieldsContainer,
    DatePicker,
  },
})
export default class ModalCrear extends Vue {
  @Prop({ default: true }) show: boolean;
  readonly funcionalidad: Funcionalidades = Funcionalidades.PreparacionEquipos;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  dialogConfirmacionGuardar: boolean = false;
  mensajeConfirmacion: any = '';
  listaModalidad: any[] = [];
  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };
  listaClientes: any[] = [];
  listaFlotas: any[] = [];

  showInfo: boolean = true;

  formFields: FormFieldDefMap = {
    requerimiento: {
      label: 'Requerimiento',
      id: 'requerimiento',
      value: '',
    },
    adp: {
      label: 'ADP',
      id: 'adp',
      value: '',
    },
    rutCliente: {
      label: 'Rut Cliente',
      id: 'rutCliente',
      value: '',
      items: [],
    },
    flota: {
      label: 'Flota',
      id: 'flota',
      value: '',
      items: [],
    },
    fecha: {
      label: 'Fecha ',
      id: 'fecha',
      value: moment(this.fechaMaxima),
    },
    serieactivamodalidad: {
      label: 'Modalidad',
      id: '',
      value: '',
    },
    oc: {
      label: 'Orden de Compra',
      id: '',
      value: '',
    },
    mandante: {
      label: 'Mandante',
      id: '',
      value: '',
    },
    asignota: {
      label: 'Nota',
      id: '',
      value: '',
    },
  };

  async getModalidad() {
    let resp: any = (await this.cargarModalidad()) || [];
    if (resp.data.CODIGO_RESPUESTA != '1') {
      this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
    } else {
      this.listaModalidad = resp.data.data;
    }
  }

  cargarModalidad() {
    this.loadingService.showLoading(undefined, 'cargarModalidad');
    let self = this;
    return fetchMS({}, 'get_modalidad')
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los AVL',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los AVL',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('cargarModalidad'));
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  async handleConfirmacionGuardar(val: boolean) {
    if (!val) {
      this.dialogConfirmacionGuardar = false;
    } else {
      let resp: any = (await this.crearRequerimiento()) || [];
      if (resp.data.CODIGO_RESPUESTA != '1') {
        this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        this.dialogConfirmacionGuardar = false;
      } else {
        this.$snotify.success(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        this.handleCerrar();
      }
    }
  }

  async crearRequerimiento() {
    this.loadingService.showLoading(undefined, 'crearRequerimiento');
    let body: any = {};
    body.requerimiento = this.formFields.requerimiento.value;
    body.adp = this.formFields.adp.value;
    body.rutCliente = this.formFields.rutCliente.value;
    body.flota = this.formFields.flota.value;
    body.fecha = this.formFields.fecha.value;
    body.modalidad = this.formFields.serieactivamodalidad.value;
    body.mandate = this.formFields.mandante.value;
    body.oc = this.formFields.oc.value;
    body.id_usuario = JSON.parse(window.localStorage.user).id;
    body.modulo = this.funcionalidad;
    body.asignota = this.formFields.asignota.value;
    let self = this;
    return fetchMS(body, 'crearRequerimiento')
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('crearRequerimiento'));
  }

  async getClientes() {
    let resp: any = (await this.cargarClientes()) || [];
    if (resp.data.CODIGO_RESPUESTA != '1') {
      this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
    } else {
      this.listaClientes = resp.data.data;
    }
  }

  cargarClientes() {
    this.loadingService.showLoading(undefined, 'getClientes');
    let self = this;
    return fetchMS({}, 'getClientes')
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('getClientes'));
  }

  async getFlotas() {
    let resp: any = (await this.cargarFlotas()) || [];
    if (resp.data.CODIGO_RESPUESTA != '1') {
      this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      this.listaFlotas = [];
    } else {
      this.listaFlotas = resp.data.data.LISTA;
    }
  }

  cargarFlotas() {
    this.loadingService.showLoading(undefined, 'getFlotas');
    let self = this;
    return fetchMS(
      { id_cliente: this.formFields.rutCliente.value },
      'getFlotas'
    )
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('getFlotas'));
  }

  created() {
    this.getClientes();
    this.getModalidad();
  }

  handleCerrar() {
    this.$emit('cerrar');
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }
  handleGuardar() {
    const isValid = true;
    this.mensajeConfirmacion =
      '¿Está seguro que desea crear este requerimiento? ';
    if (isValid) {
      this.dialogConfirmacionGuardar = true;
    }
  }
}
